var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconAssignment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.3327 30.1333H13.7993C12.0727 30.1333 10.666 28.7267 10.666 27V15.1333C10.666 13.4067 12.0727 12 13.7993 12H16.066V13.4667H13.7993C12.8793 13.4667 12.1327 14.2133 12.1327 15.1333V27C12.1327 27.92 12.8793 28.6667 13.7993 28.6667H26.3327C27.2527 28.6667 27.9993 27.92 27.9993 27V15.1333C27.9993 14.2133 27.2527 13.4667 26.3327 13.4667H24.066V12H26.3327C28.0593 12 29.466 13.4067 29.466 15.1333V27C29.466 28.7267 28.0593 30.1333 26.3327 30.1333Z",
    fill: "#333436"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.266 15.4667H16.866C16.0193 15.4667 15.3327 14.78 15.3327 13.9333V11.5333C15.3327 10.6867 16.0193 10 16.866 10H23.266C24.1127 10 24.7993 10.6867 24.7993 11.5333V13.9333C24.7993 14.78 24.1127 15.4667 23.266 15.4667ZM16.866 11.4667C16.826 11.4667 16.7993 11.4933 16.7993 11.5333V13.9333C16.7993 13.9733 16.826 14 16.866 14H23.266C23.306 14 23.3327 13.9733 23.3327 13.9333V11.5333C23.3327 11.4933 23.306 11.4667 23.266 11.4667H16.866Z",
    fill: "#333436"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.066 19H15.066V20.4667H25.066V19Z",
    fill: "#333436"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.066 23.6667H15.066V25.1333H25.066V23.6667Z",
    fill: "#333436"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAssignment);
export default __webpack_public_path__ + "static/media/icon_assignment.7c67df9d.svg";
export { ForwardRef as ReactComponent };